import styled from 'styled-components'
import PropTypes from 'prop-types'
import { P } from 'common/typography'
import { COMPLETED, INPROGRESS, INREVIEW } from 'utils/project-status'
import isRecent from 'utils/is-recent'

/* Move the text description from the center to the bottom leeft corner */
const PStyled = styled(P)`
  color: var(--lightBlue);
  font-weight: 700;
`

// animation="revision-text" width="48.12px"
// animation="feedback-text" width="81.565px"
// animation="completed-text" width="53.6px"

const ProjectStatusStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px 16px;
  background: linear-gradient(180deg,rgba(255,255,255,0) -60.31%,rgba(65,62,84,0.5) 42.27%,rgba(4,0,30,0.9) 71.78%);
  background-position: bottom;
  background-size: 588px 1400px;
  animation-name: fadeIn, background-change;
  animation-fill-mode: forwards;
  animation-duration: ${({ isAnimated }) => (isAnimated ? '0.5s, 1s' : '0s')};
  animation-delay: ${({ isAnimated }) => (isAnimated ? '0s, 3s' : '0s')};
  opacity: 0;
  text-align: center;
  .scale-down {
    width: 128px;
    height: 128px;
    position: absolute;
    animation: scaleDown;
    animation-fill-mode: forwards;
    animation-duration: 1s;
    animation-delay: 3s;
    left: calc(50% - 64px);
    top: calc(50% - 64px);
    bottom: calc(50% - 64px);
  }
  .animated {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
    animation-duration: 2s, 1s;
    animation-delay: 1s, 3s;
    animation-fill-mode: backwards, forwards;
    animation-iteration-count: 1;
    background-size: 3456px 128px;
    background-position: bottom;
    animation-name: animate-sprite, backgroundScale;
  }
  .static-icon {
    position: absolute;
    width: 64px;
    height: 64px;
    bottom: 20px;
    left: 16px;
    background-size: 1728px 64px;
  }
  .static-text {
    position: absolute;
    left: 80px;
    bottom: 45px;
  }
  .revision-icon {
    background-image: url(/images/profile/revision-sprite.png);
  }
  .revision-steps {
    animation-timing-function: steps(27), ease-in-out;
  }
  .completed-icon {
    background-image: url(/images/profile/completed-sprite.png);
  }
  .completed-steps {
    animation-timing-function: steps(27), ease-in-out;
  }
  .feedback-icon {
    background-image: url(/images/profile/feedback-sprite.png);
  }
  .feedback-steps {
    animation-timing-function: steps(25), ease-in-out;
  }
  .animated-text {
    height: 22px;
    position: absolute;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-duration: 1s;
    animation-delay: 3s;
    bottom: calc(50% - 88px);
    top: calc(50% + 64px);
  }
  .review-text {
    animation-name: textScaleDown, reviewText;
    left: calc(50% - 48.22px);
  }
  .feedback-text {
    animation-name: textScaleDown, feedbackText;
    left: calc(50% - 81.56px);
  }
  .completed-text {
    animation-name: textScaleDown, completeText;
    left: calc(50% - 53.6px);
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes backgroundScale {
    from {
      background-size: 3456px 128px;
    }
    55% {
      background-size: 1728px 64px;
    }
    to {
      background-size: 1728px 64px;
    }
  }
  /* Change the background color from a solid to a gradient */
  @keyframes background-change {
    from { background-size: 588px 1400px; }
    to { background-size: 588px 350px; }
  }
  /* Move the text description from the center to the bottom leeft corner */
  @keyframes reviewText {
    from { left: calc(50% - 48.22px);}
    to { left: 80px; }
  }
  @keyframes feedbackText {
    from { left: calc(50% - 81.56px);}
    to { left: 80px; }
  }
  @keyframes completeText {
    from { left: calc(50% - 53.6px);}
    to { left: 80px; }
  }
  @keyframes textScaleDown {
    from { bottom: calc(50% - 88px); top: calc(50% + 64px); }
    to { bottom: 64px; top: calc(100% - 64px);}
  }
  /* Moves and Scale the icon from the center to the bottom left corner */
  @keyframes scaleDown {
    from {
      left: calc(50% - 64px);
      top: calc(50% - 64px);
      bottom: calc(50% - 64px);
      width: 128px;
      height: 128px;
    }
    to {
      top: calc(100% - 84px);
      bottom: 20px;
      left: 16px;
      width: 64px;
      height: 64px;
    }
  }
  /* Animate the inicial spite of the icon */
  @keyframes animate-sprite {
    from { background-position: 0; }
    to { background-position: -3456px; }
  }
`

function ProjectStatus({
  status, feedback, show, updated_at: updated, completed_date: completed,
}) {

  if (show && status === INREVIEW) {
    const sendendRecent = isRecent({
      time: updated,
      timeDiference: 60,
      timeUnit: 'mm',
    })
    // We show the animations of a project in revison if was sendend
    // in the last hour to indicate that we are working on his evaluation.
    // We wait until the element is intersectig to show the animation.
    if (show && sendendRecent) {
      return (
        <ProjectStatusStyled className="project-status-styled" isAnimated>
          <div className="scale-down">
            <div className="animated revision-steps revision-icon" />
          </div>
          <PStyled className="animated-text review-text">En revisión.</PStyled>
        </ProjectStatusStyled>
      )
    }
    if (!sendendRecent) {
      return (
        <ProjectStatusStyled className="project-status-styled">
          <div className="static-icon-container">
            <div className="static-icon revision-icon" />
          </div>
          <PStyled className="static-text">En revisión.</PStyled>
        </ProjectStatusStyled>
      )
    }
  }

  // We always show the animations on a project with
  // feedback to atact the attencion from the user.
  // We wait until the element is intersectig to show the animation.
  if (show && status === INPROGRESS && feedback) {
    return (
      <ProjectStatusStyled className="project-status-styled" isAnimated>
        <div className="scale-down">
          <div className="animated feedback-steps feedback-icon" />
        </div>
        <PStyled className="animated-text feedback-text">Contiene feedback.</PStyled>
      </ProjectStatusStyled>
    )
  }

  if (status === COMPLETED) {
    const completedRecent = isRecent({
      time: completed,
      timeDiference: 2,
      timeUnit: 'dd',
    })
    // We always show the animations on a completed if was aproved
    // in the last 48 hours to celebrate his success.
    // We wait until the element is intersectig to show the animation.
    if (show && completedRecent) {
      return (
        <ProjectStatusStyled className="project-status-styled" isAnimated>
          <div className="scale-down">
            <div className="animated completed-steps completed-icon"/>
          </div>
          <PStyled className="animated-text completed-text">Completado.</PStyled>
        </ProjectStatusStyled>
      )
    }
    if (!completedRecent) {
      return (
        <ProjectStatusStyled className="project-status-styled">
          <div className="static-icon-container">
            <div className="static-icon completed-icon" />
          </div>
          <PStyled className="static-text">Completado.</PStyled>
        </ProjectStatusStyled>
      )
    }
  }

  return null
}

ProjectStatus.defaultProps = {
  feedback: null,
  completed_date: '',
  show: false,
}

ProjectStatus.propTypes = {
  // One of utils/projects-status
  status: PropTypes.string.isRequired,
  feedback: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ),
  // The signal if the project is intersecting
  show: PropTypes.bool,
  // Date in format '2021-01-28 02:03:10Z'
  updated_at: PropTypes.string.isRequired,
  completed_date: PropTypes.string,
}

export default ProjectStatus
